import { getEntityType } from '@the-real-insight/tri-model';

/**
 * Die Klasse zu einem Typnamen — oder `undefined`, wo das Modell ihn nicht kennt.
 *
 * `getEntityType` wirft bei einem unbekannten Namen. Eine Referenz kann aber auf eine abstrakte
 * Klasse zeigen (`Entity`) oder auf einen Typ, den es nicht mehr gibt, und eine Seite, die daran
 * zerbricht, zeigt gar nichts statt „unbekannter Typ".
 */
export const knownEntityType = (name: string | null | undefined): any => {
    if (!name) return undefined;
    try {
        return getEntityType(name) as any;
    } catch {
        return undefined;
    }
};
